
import Img from '@/images';

import styles from './styles.module.scss';

const HiringEasierDotsShape = () => (
    <Img className={styles['dot-shape']} src="static/images/free-tools-for-managers/decorative/hiring-easier-shapes-dots.svg" />
);


export default HiringEasierDotsShape;
